import { config } from '../config';

export const geocoder = {
  search: async (q, types, bbox) => {
    const url = `${config.url.GEOCODER_URL}/${q}.json?`+ new URLSearchParams({
      bbox: `${bbox}`,
      types,
      limit: 10,
      key: config.token.MAPTILER_KEY,
    });
    const results = fetch(url).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Something went wrong');
    })
      .catch((error) => {
        console.log(error);
      });
    return results;
  },
};